<template>
  <div class="filterCnt">
    <div class="filterTitle">
      <div class="filterToggle" v-on:click="$emit('filterToggle')"></div>
    </div>
    <perfect-scrollbar class="filterSc">
      <div class="filterSection account" :class="{active: menuActive === 'account'}">
        <a href="/user/account">Pengaturan Akun</a>
      </div>
      <div class="filterSection address" :class="{active: menuActive === 'address'}">
        <a href="/user/alamat">Daftar Alamat</a>
      </div>
      <div class="filterSection transaction">
        <a href="/user/transaksi">Transaksi</a>
        <div class="submenu">
          <a href="/user/transaksi" :class="{active: menuActive === 'trx'}">Semua transaksi</a>
          <a href="/user/transaksi?status=ongoing"
            :class="{active: menuActive === 'trxOngoing'}">Transaksi berlangsung</a>
          <a href="/user/transaksi?status=success"
            :class="{active: menuActive === 'trxSuccess'}">Transaksi sukses</a>
          <a href="/user/transaksi?status=failed"
            :class="{active: menuActive === 'trxCanceled'}">Transaksi dibatalkan</a>
        </div>
      </div>
    </perfect-scrollbar>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['menuActive'],
  data() {
    return {};
  },
  methods: {
    doNothing() {},
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.filterCnt{
  position: fixed;
  top: 76px; left: 0; bottom: 0;
  width: 50px;
  border-right: #eee 1px solid;
  background-color: #fff;
  z-index: 97;
  @media (max-width: 1140px) {
    transition: all .3s ease;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    width: 300px;
  }
  @media (max-width: 760px) {
    top: 60px;
  }
  .filterSc{
    position: absolute;
    top: 49px; left: 0; right: 0; bottom: 0;
    overflow-y: auto;
    padding: 10px 0 120px;
    display: none;
    @media (max-width: 1140px) {
      transition: all .3s ease;
      display: block;
      opacity: 1;
    }
  }
  .filterTitle{
    font-size: 20px;
    border-bottom: #eee 1px solid;
    font-weight: 400;
    position: relative;
    height: 45px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    @media (max-width: 1140px) {
      padding: 14px 20px 8px;
    }
    span{
      display: none;
      @media (max-width: 1140px) {
        display: inline-block;
      }
    }
    .filterToggle{
      position: absolute;
      right: 10px; top: 6px;
      width: 30px; height: 30px;
      background-image: url(../assets/arrow-right.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
      cursor: pointer;
      transition: all .3s ease;
      @media (max-width: 1140px) {
        background-image: url(../assets/arrow-left.png);
      }
      &:hover{
        background-color: #eee;
      }
    }
  }
  .filterSection{
    position: relative;
    a{
      font-size: 16px;
      font-weight: 400;
      margin: 0;
      display: block;
      padding: 10px 20px;
      padding-left: 60px;
      margin-bottom: 5px;
      color: #444;
      font-weight: 600;
      &:hover{
        background-color: #f5f5fe;
      }
      &:before{
        content: "";
        position: absolute;
        width: 24px; height: 24px;
        left: 20px; top: 8px;
        background-image: url(../assets/up-arrow.png);
        background-size: 24px auto;
        background-position: center;
        background-repeat: no-repeat;
        transition: all .3s ease;
      }
    }
    &.active{
      a{
        background-color: #f5f5fe;
      }
    }
    &.account{
      a:before{
        background-image: url(../assets/account-2.png);
      }
    }
    &.address{
      a:before{
        background-image: url(../assets/document.png);
      }
    }
    &.transaction{
      a:before{
        background-image: url(../assets/transaction.png);
        background-size: 24px;
      }
    }
    .submenu{
      border-left: #999 2px solid;
      margin-left: 30px;
      a{
        padding-left: 30px;
        font-weight: 500;
        // padding: 8px 20px;
        // padding-left: 30px;
        &.active{
          background-color: #f5f5fe;
        }
      }
    }
  }
}
.filterOpen{
  .filterCnt{
    width: 301px;
    @media (max-width: 1140px) {
      left: -250px;
      box-shadow: none;
    }
    @media (max-width: 680px) {
      // left: -300px;
    }
    .filterTitle{
      padding: 11px 20px 0;
      padding-left: 48px;
      @media (max-width: 680px) {
        padding-left: 0;
      }
      span{
        display: inline-block;
      }
      .filterToggle{
        background-image: url(../assets/arrow-left.png);
        @media (max-width: 1140px) {
          background-image: url(../assets/arrow-right.png);
          // background-image: url(../assets/filter.png);
        }
      }
    }
    .filterSc{
      display: block;
      @media (max-width: 1140px) {
        opacity: 0;
      }
    }
  }
}
</style>
